"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateTimeSQLiteHandler", {
    enumerable: true,
    get: function() {
        return DateTimeSQLiteHandler;
    }
});
const _datetimegeneralhandler = require("./date-time.general.handler");
let DateTimeSQLiteHandler = class DateTimeSQLiteHandler extends _datetimegeneralhandler.DateTimeGeneralHandler {
    async parseUserInput(params) {
        const dayjsUtcValue = super.parseDateTime(params).value;
        // convert to UTC
        // e.g. 2022-01-01T10:00:00.000Z -> 2022-01-01 04:30:00+00:00
        const val = dayjsUtcValue == null ? void 0 : dayjsUtcValue.format('YYYY-MM-DD HH:mm:ssZ');
        return {
            value: val
        };
    }
};
